import userManager from "../auth/userManager";

// Dedupes concurrent OIDC silent-renewal attempts behind a single in-flight
// promise (see docs/specs/0001-oidc-migration.md) - the OIDC-path equivalent
// of the legacy axios interceptor's isRefreshing/refreshSubscribers queuing,
// but backed by the OIDC library's own renewal mechanics (a refresh_token
// exchange, since oidcConfig requests the offline_access scope) instead of a
// hand-rolled refresh call.
let inFlightRenewal = null;

export function renewOidcSession() {
  if (!inFlightRenewal) {
    inFlightRenewal = userManager
      .signinSilent()
      .catch(async (err) => {
        try {
          await userManager.removeUser();
        } catch (removeErr) {
          // ignore
        }
        throw err;
      })
      .finally(() => {
        inFlightRenewal = null;
      });
  }
  return inFlightRenewal;
}
